import { View as RNView } from "react-native";
import { withLayoutProps } from "~/hoc/withLayoutProps";
import type React from "react";

export const View = withLayoutProps(RNView);
export type View = typeof View;
export type ViewProps = React.ComponentProps<View>;
